"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEscrowAuthority = exports.escrowAuthority = exports.getEscrowAuthoritySerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getEscrowAuthoritySerializer() {
    return (0, serializers_1.dataEnum)([
        ['TokenOwner', (0, serializers_1.unit)()],
        [
            'Creator',
            (0, serializers_1.struct)([
                ['fields', (0, serializers_1.tuple)([(0, serializers_1.publicKey)()])],
            ]),
        ],
    ], { description: 'EscrowAuthority' });
}
exports.getEscrowAuthoritySerializer = getEscrowAuthoritySerializer;
function escrowAuthority(kind, data) {
    return Array.isArray(data)
        ? { __kind: kind, fields: data }
        : { __kind: kind, ...(data ?? {}) };
}
exports.escrowAuthority = escrowAuthority;
function isEscrowAuthority(kind, value) {
    return value.__kind === kind;
}
exports.isEscrowAuthority = isEscrowAuthority;
//# sourceMappingURL=escrowAuthority.js.map